import { http, createConfig } from "wagmi";
import { injected } from "wagmi/connectors";
import { bsc } from "wagmi/chains";
import { env } from "./env";

export const targetChain = bsc;

export const wagmiConfig = createConfig({
  chains: [targetChain],
  connectors: [injected()],
  transports: {
    [targetChain.id]: http(env.rpcUrl),
  },
});
